import React, { Component } from "react";
import "styled-components/macro";

export default class MouseCursor extends Component {
  render() {
    return (
      <g
        css={`
          transform-origin: 60% 50% 0;
          ${this.props.animationStep >= 3
            ? `animation-iteration-count: 2;
          animation-delay: ${this.props.animationMs}ms;
          animation-name: clickclack;
          animation-duration: ${this.props.animationMs}ms;
          animation-play-state: ${
            this.props.animationStep >= 3 ? "running" : "paused"
          };
          transform: scale(1);
          @keyframes clickclack {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(0.95);
            }
            100% {
              transform: scale(1);
            }

          }
`
            : ""}
        `}
      >
        <g id="mouse-cursor">
          <svg
            viewBox="0 0 58 74"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="58px"
            height="74px"
          >
            <path
              d="M49.1565 68.0201C49.6103 67.9066 50.0185 67.6571 50.3262 67.305C50.6339 66.9528 50.8263 66.5151 50.8775 66.0506L57.6625 2.97416C57.699 2.5509 57.6168 2.12591 57.4251 1.74683C57.2334 1.36775 56.9397 1.04957 56.577 0.827962C56.2143 0.606353 55.797 0.490074 55.3717 0.49216C54.9465 0.494246 54.5301 0.614616 54.1694 0.839775L1.90418 36.9182C1.51275 37.1897 1.21579 37.5764 1.05468 38.0243C0.893577 38.4723 0.876353 38.9592 1.00541 39.4172C1.13447 39.8753 1.40338 40.2816 1.77467 40.5796C2.14595 40.8776 2.60111 41.0523 3.07672 41.0796L23.0737 42.0752L9.31533 65.141C9.00722 65.661 8.91757 66.2816 9.06595 66.8672C9.21434 67.4529 9.58871 67.9559 10.1073 68.2665L19.1734 73.6595C19.4328 73.8124 19.7199 73.9126 20.0182 73.9544C20.3166 73.9962 20.6203 73.9788 20.912 73.9031C21.2045 73.8308 21.4798 73.7015 21.7223 73.5226C21.9647 73.3438 22.1695 73.119 22.3248 72.861L36.1329 49.7118L46.6493 66.9805C46.8972 67.3918 47.2685 67.7147 47.7106 67.9033C48.1526 68.092 48.643 68.1367 49.1121 68.0313L49.1565 68.0201ZM35.5586 43.1578C35.2661 43.2301 34.9908 43.3594 34.7483 43.5382C34.5059 43.717 34.3011 43.9419 34.1458 44.1999L19.5752 68.6274L14.4578 65.4892L28.9788 41.145C29.1795 40.8069 29.2896 40.4229 29.2985 40.03C29.3075 39.6371 29.2149 39.2486 29.0297 38.9019C28.8446 38.5553 28.5731 38.2622 28.2415 38.051C27.9098 37.8397 27.5293 37.7175 27.1365 37.6959L10.077 36.8289L52.6505 7.42877L47.0477 58.859L38.0767 44.1474C37.8737 43.8099 37.5868 43.5305 37.2438 43.3364C36.9008 43.1423 36.5134 43.0399 36.1191 43.0394L35.5586 43.1578Z"
              fill="#333333"
            />
          </svg>
        </g>
      </g>
    );
  }
}
